__turbopack_context__.v({
  "card": "AuthorCard-module-scss-module__iHrssW__card",
  "icon": "AuthorCard-module-scss-module__iHrssW__icon",
  "info": "AuthorCard-module-scss-module__iHrssW__info",
  "link": "AuthorCard-module-scss-module__iHrssW__link",
  "name": "AuthorCard-module-scss-module__iHrssW__name",
  "role": "AuthorCard-module-scss-module__iHrssW__role",
});
